import serviceCommon from './common';

const getAgreeStatusUrl = '/saos-mids-api/user_info'; // 查询阅读协议状态
const setAgreeStatusUrl = '/saos-mids-api/user_info/read_agreements'; // 确认阅读协议

export default {
    // 查询阅读协议状态
    async getAgreeStatus() {
        const response = await serviceCommon.serviceAjax(
            getAgreeStatusUrl,
            'get'
        );
        return response;
    },
    // 确认阅读协议
    async setAgreeStatus() {
        const response = await serviceCommon.serviceAjax(
            setAgreeStatusUrl,
            'post'
        );
        return response;
    }
};
